import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IMeeting } from '~/types/meeting/models'

const apiEntityPath = '/api/meetings'

// export async function getMeetings({ apiPath = '/api/meetings' } = {}) {
//   const meetingingMn = getMeetings.name
//   return httpGet<IMeeting[]>({ meetingingMn, apiPath })
// }

export async function createMeeting(entity: IMeeting) {
  const callingMn = createMeeting.name
  const apiPath = apiEntityPath
  return httpPost<IMeeting>({ callingMn, apiPath, entity })
}

export async function updateMeeting(
  entityData: Partial<IMeeting>,
  id: TEntityId
) {
  const callingMn = updateMeeting.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIMeeting = Partial<IMeeting>
  return httpPatchMerge<TPartialIMeeting>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteMeeting(entityData: IMeeting) {
  const callingMn = deleteMeeting.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
